import React from 'react';
import { z } from 'zod';
import { getPadding, PADDING_SCHEMA } from '../padding';
export const AvatarPropsSchema = z.object({
    style: z
        .object({
        textAlign: z.enum(['left', 'center', 'right']).optional().nullable(),
        padding: PADDING_SCHEMA,
    })
        .optional()
        .nullable(),
    props: z
        .object({
        size: z.number().gt(0).optional().nullable(),
        shape: z.enum(['circle', 'square', 'rounded']).optional().nullable(),
        imageUrl: z.string().optional().nullable(),
        alt: z.string().optional().nullable(),
    })
        .optional()
        .nullable(),
});
function getBorderRadius(shape, size) {
    switch (shape) {
        case 'rounded':
            return size * 0.125;
        case 'circle':
            return size;
        case 'square':
        default:
            return undefined;
    }
}
export function Avatar({ style, props }) {
    var _e;
    const size = props === null || props === void 0 ? void 0 : props.size;
    const imageUrl = props === null || props === void 0 ? void 0 : props.imageUrl;
    const alt = props === null || props === void 0 ? void 0 : props.alt;
    const shape = props === null || props === void 0 ? void 0 : props.shape;
    const sectionStyle = {
        textAlign: (_e = style === null || style === void 0 ? void 0 : style.textAlign) !== null && _e !== void 0 ? _e : undefined,
        padding: getPadding(style === null || style === void 0 ? void 0 : style.padding),
    };
    return (React.createElement("div", { style: sectionStyle },
        React.createElement("img", { alt: alt, src: imageUrl, height: size, width: size, style: {
                outline: 'none',
                border: 'none',
                textDecoration: 'none',
                objectFit: 'cover',
                height: size,
                width: size,
                maxWidth: '100%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'center',
                borderRadius: getBorderRadius(shape, size),
            } })));
}
//# sourceMappingURL=Avatar.js.map